import { useEffect, useState } from 'react';
import { Cookie } from 'lucide-react';
import { getConsent, setConsent, hasDecided } from '../../utils/consent';
import { loadAnalytics } from '../../utils/analytics';

// Banner de consentimento LGPD. Aparece na primeira visita. Enquanto o usuário
// não decide, o Google Analytics NÃO é carregado (só o essencial roda). Se ele
// já decidiu antes e aceitou analytics, o GA é carregado no mount.
//
// Categorias:
//  - Essenciais: sempre ativas (localStorage de progresso + infraestrutura). Não desligáveis.
//  - Análise (GA4): opt-in.
// A plataforma NÃO usa cookies de publicidade.

const BASE = (import.meta as { env?: { BASE_URL?: string } }).env?.BASE_URL ?? '/';
const COOKIES_URL = `${BASE}legal/politica-de-cookies.html`;

export function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  // Restaura decisão anterior: se já aceitou analytics, carrega o GA.
  useEffect(() => {
    const prev = getConsent();
    if (prev) {
      if (prev.analytics) loadAnalytics();
    } else {
      setVisible(true);
    }
  }, []);

  if (!visible || hasDecided()) return null;

  const decide = (analytics: boolean) => {
    setConsent(analytics);
    if (analytics) loadAnalytics();
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-label="Aviso de cookies e privacidade"
      className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4 animate-in slide-in-from-bottom-4 duration-300"
    >
      <div className="mx-auto w-full max-w-2xl glass-panel rounded-2xl border-sky-500/30 shadow-neon-cyan bg-slate-900/95 p-3.5 sm:p-4 flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <Cookie className="text-amber-400 shrink-0 mt-0.5 sm:mt-0" size={22} />
        <p className="text-slate-300 text-fluid-sm leading-snug flex-1">
          Usamos armazenamento <strong className="text-slate-100">essencial</strong> para salvar seu
          progresso neste dispositivo (sem dados pessoais). Com sua permissão, usamos também{' '}
          <strong className="text-slate-100">análise</strong> (Google Analytics) para entender o uso e
          melhorar a plataforma. Não veiculamos publicidade.{' '}
          <a href={COOKIES_URL} target="_blank" rel="noopener noreferrer" className="text-sky-400 hover:text-sky-300 underline font-medium">
            Política de Cookies
          </a>.
        </p>
        <div className="flex gap-2 shrink-0 w-full sm:w-auto">
          <button
            onClick={() => decide(false)}
            className="btn-cyber flex-1 sm:flex-none px-3 py-2 rounded-xl bg-slate-800 border border-slate-600 text-slate-200 font-cyber font-bold text-fluid-xs uppercase tracking-wider hover:bg-slate-700 transition"
          >
            Apenas essenciais
          </button>
          <button
            onClick={() => decide(true)}
            className="btn-cyber flex-1 sm:flex-none px-4 py-2 rounded-xl bg-emerald-600 border border-emerald-400 text-white font-cyber font-bold text-fluid-xs uppercase tracking-wider hover:bg-emerald-500 shadow-neon-emerald transition"
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  );
}
